<template>
  <div>
    <div class="content-box">
      <div class="album">
        <img class="album-img" :src="baseURL+'/'+album.album.photo">
        <div>
          <div class="name">{{ album.album.name }}</div>
          <div>
            <span style="margin-right: 10px">{{ new Date(album.album.albumDate).Format("yyyy年M月d日") }}</span>
            <span>{{ album.pictures.length }}张</span>
          </div>
        </div>
      </div>
      <div class="line" />
      <div class="picture-box">
        <div v-for="(item,index) in album.pictures" :key="item.id" class="picture">
          <div class="img-box">
            <img :src="baseURL+'/'+item.photo" @click="onClickImg(index)">
          </div>
        </div>
      </div>
    </div>
    <viewer
      ref="viewer"
      :options="options"
      :images="album.pictures"
      class="viewer"
      @inited="inited"
    >
      <img v-for="picture in album.pictures" :key="picture.id" :src="baseURL+'/'+picture.photo" class="viewer-img">
    </viewer>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component.vue'

export default {
  name: 'Picture',
  components: {
    Viewer
  },
  data() {
    return {
      albumId: this.$route.params.albumId,
      album: {},
      baseURL: process.env.VUE_APP_BASE_API,
      options: {
        'title': false,
        'keyboard': false
      }
    }
  },
  created() {
    this.$axios.get(this.$api.listPicture, { params: { albumId: this.albumId }}).then(res => {
      this.album = res.data
    })
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer
    },
    onClickImg(index) {
      this.$viewer.view(index)
    }
  }
}
</script>

<style lang="stylus" scoped>
.album
  margin 47px 0
  display flex
  align-items center
  font-size 18px
  color rgba(31,46,65,1)
  .album-img
    margin-right 25px
    object-fit cover
    width 140px
    height 100px
  .name
    margin-bottom 11px
    font-weight 600
    font-size 30px
  span
    opacity 0.39
.line
  width 100%
  height 1px
  background rgba(216,216,216,1)
.picture-box
  display flex
  flex-wrap wrap
  margin-bottom 50px
  .picture
    padding 10px
    background white
    box-sizing border-box
    margin-right 2%
    width 32%
    margin-top 30px
    &:nth-child(3n)
      margin-right 0
    .img-box
      padding-bottom 66.4%
      height 0
      position relative
      img
        cursor pointer
        width 100%
        height 100%
        position absolute
        object-fit cover
.viewer-img
  display none
</style>
